import Offcanvas from 'bootstrap/js/dist/offcanvas';
import * as Popper from "@popperjs/core";

// navbar scroll
function navbarScroll() {
    const navbar = document.querySelector('.navbar--custom');
    const top = 200;
    if (window.innerWidth > 991) {
        window.addEventListener('scroll', function() {
            if (window.scrollY > top) {
                navbar.classList.remove('navbar--transparent');
            } else {
                navbar.classList.add('navbar--transparent');
            }
        });
    } else {
        navbar.classList.remove('navbar--transparent');
    }
}
export { navbarScroll };

// page banner margin-top
function pageBannerTop () {
    const navHeight = document.querySelector('.navbar--custom').offsetHeight;
    console.log(navHeight);
    const pageBanner = document.querySelector('.page-banner');
    pageBanner.style.marginTop = navHeight + "px";
}
export { pageBannerTop };

// web loading
window.addEventListener('load', function() {
    const loader = document.getElementById('loader');
    loader.style.display = 'none';
});

// menu polylang
function menuLang() {
    const menuLangs = document.querySelectorAll('.pll-parent-menu-item');
    menuLangs.forEach(lang => {
        lang.addEventListener('click', function() {
            lang.classList.toggle('open');
        });
    });
}
export { menuLang };